declare global {
  interface Window {
    _hmt: any[];
  }
}

export const baiduAnalytics = {
  /**
   * 检查百度统计是否已加载
   */
  isLoaded: (): boolean => {
    return typeof window !== 'undefined' && typeof window._hmt !== 'undefined';
  },

  /**
   * 检查百度统计脚本是否已加载
   */
  isScriptLoaded: (): boolean => {
    if (typeof window === 'undefined') return false;
    const scripts = document.getElementsByTagName('script');
    for (let i = 0; i < scripts.length; i++) {
      if (scripts[i].src && scripts[i].src.includes('hm.baidu.com')) {
        return true;
      }
    }
    return false;
  },

  /**
   * 追踪页面浏览量（PV）
   * @param path 页面路径，如 '/page' 或 '/page?id=123'
   */
  trackPageView: (path: string) => {
    if (typeof window !== 'undefined' && window._hmt) {
      window._hmt.push(['_trackPageview', path]);
    }
  },

  /**
   * 追踪事件
   * @param category 事件类别
   * @param action 事件动作
   * @param label 事件标签（可选）
   * @param value 事件值（可选）
   */
  trackEvent: (category: string, action: string, label?: string, value?: number) => {
    if (typeof window !== 'undefined' && window._hmt) {
      const event: any[] = ['_trackEvent', category, action];
      if (label) event.push(label);
      if (value !== undefined) event.push(value);
      window._hmt.push(event);
    }
  },

  /**
   * 设置自定义变量（用于UV统计）
   * @param index 变量索引（1-5）
   * @param name 变量名称
   * @param value 变量值
   * @param scope 作用域：1-访问级别，2-会话级别，3-页面级别
   */
  setCustomVar: (index: number, name: string, value: string, scope: number = 1) => {
    if (typeof window !== 'undefined' && window._hmt) {
      window._hmt.push(['_setCustomVar', index, name, value, scope]);
    }
  },

  /**
   * 设置用户ID（用于UV统计）
   * @param userId 用户ID
   */
  setUserId: (userId: string) => {
    if (typeof window !== 'undefined' && window._hmt) {
      // 使用自定义变量1存储用户ID（访问级别，整个访问期间有效）
      window._hmt.push(['_setCustomVar', 1, '用户ID', userId, 1]);
    }
  },

  /**
   * 追踪UV（独立访客）
   * 通过设置用户ID，百度统计会自动识别UV
   * @param userId 用户唯一标识
   */
  trackUV: (userId: string) => {
    if (typeof window !== 'undefined' && window._hmt) {
      baiduAnalytics.setUserId(userId);
    }
  },
};
